export default "__VITE_ASSET__CUprewhe__"